import type { BackendModule } from 'i18next'

import { supportedLocales } from '../i18nConfig'
import type { AppLocale } from '../types'

export const TranslationLoader = (): BackendModule => {
  return {
    type: 'backend',
    init: () => {
      // nothing to do
    },
    read: (language: AppLocale, _namespace, callback) => {
      if (!supportedLocales[language]) {
        return callback(new Error('Unknown language ' + language), null)
      }
      supportedLocales[language]
        .translationFileLoader()
        .then((resource) => {
          callback(null, resource)
        })
        .catch((error) => {
          const er = error instanceof Error ? error : new Error('unknown')
          callback(er, null)
        })
    },
  }
}
